//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            focus: false,
            inner_val: this.value,
            initial_val: this.value
        }
    },
    computed: {
        is_default () {
            return this.initial_val == this.inner_val
        }
    },
    methods: {
        onFocus () {
            this.focus = true
        },
        onBlur () {
            this.focus = false
        },
        change (e) {
            const { mp: { detail: { value } } } = e
            this.inner_val = value
            setTimeout(() => this.$emit('input', this.inner_val))
        }
    },
    props: {
        value: {
            type: [String, Number]
        },
        type: {
            type: String
        }
    }
}
